export default __webpack_public_path__ + "static/media/googleplay.5d9a073b.png";